<template>
<div class="page">
  <div class="m-b-24 bg-content padding15">
    <el-form size="small" label-width="150px" class="margin15-tb">
      <el-row :gutter="24" v-if="this.$partB()">
        <el-col :span="8">
          <el-form-item label="绑定合同:">&nbsp;&nbsp;&nbsp;
            <span v-if="!this.agreement">
              <el-button type="text" plain @click="agreements = null; agreementDivConfigVisible = true; getAgreement();">立即绑定</el-button>
            </span>
            <span style="color: #00C700" v-else><i class="el-icon-check">已绑定</i>&nbsp;&nbsp;&nbsp;&nbsp;<el-button type="text" plain @click="agreements = null; agreementDivConfigVisible = true; getAgreement();">重新绑定</el-button></span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="8">
          <el-form-item label="绑定日蚀账号:">&nbsp;&nbsp;&nbsp;
            <span v-if="!this.zytUsers"><el-button type="text" plain @click="registerZYTShow">立即绑定</el-button></span>
            <span style="color: #00C700" v-else><i class="el-icon-check">已绑定</i>&nbsp;&nbsp;&nbsp;&nbsp;<el-button type="text" plain @click="registerZYTShow">重新绑定</el-button></span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="8">
          <el-form-item label="测试公司:" v-if="this.$partB()">&nbsp;&nbsp;&nbsp;
            <el-switch
              v-model="onoffTesting"
              active-color="#f6ac19"
              inactive-color="#282828">
            </el-switch>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="8">
          <el-form-item label="是否使用抬头开关:" v-if="this.$partB()">&nbsp;&nbsp;&nbsp;
            <el-switch
              v-model="onoffTitle"
              active-color="#f6ac19"
              inactive-color="#282828">
            </el-switch>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="8">
          <el-form-item label="是否使用自定义抬头:" v-if="this.$partB() && onoffTitle">&nbsp;&nbsp;&nbsp;
            <el-switch
              v-model="onoffCaseTitle"
              active-color="#f6ac19"
              inactive-color="#282828">
            </el-switch>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="8">
          <el-form-item label="合并案件作业:">&nbsp;&nbsp;&nbsp;
            <div style="display: inline-block">
              <el-switch v-model="comboxCase" active-color="#f6ac19" inactive-color="#282828" :active-value="1" :inactive-value="0"/>
            </div>
            <div style="display: inline-block; margin-left: 10px;">
              <el-tooltip class="item" effect="light" placement="right">
                <div slot="content">
                  合并案件作业会将同日导入、相同身份证号、同样的作业天数合并作业、<br/>
                  相同策略号，以第一个案件作为主案统一发送，并且合并所以子案的作业金额，<br/>
                  后导入的案件状态会与主案同步，全部子案都核实还款才会停止作业。
                </div>
                <i class="el-icon-question"></i>
              </el-tooltip>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24" v-if="this.$partB()">
        <el-col :span="8">
          <el-form-item label="合并策略组:">&nbsp;&nbsp;&nbsp;
            <div style="display: inline-block">
              <el-switch v-model="mergeGroup" active-color="#f6ac19" inactive-color="#282828" :active-value="1" :inactive-value="0"/>
            </div>
            <div style="display: inline-block; margin-left: 10px;">
              <el-tooltip class="item" effect="light" placement="right">
                <div slot="content">
                  当天相同策略组的案子合并为一个批次
                </div>
                <i class="el-icon-question"></i>
              </el-tooltip>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24" v-if="this.$partB()">
        <el-col :span="8">
          <el-form-item label="导入同步更新:">&nbsp;&nbsp;&nbsp;
            <div style="display: inline-block">
              <el-switch v-model="importUpdate" active-color="#f6ac19" inactive-color="#282828" :active-value="1" :inactive-value="0"/>
            </div>
            <div style="display: inline-block; margin-left: 10px;">
              <el-tooltip class="item" effect="light" placement="right">
                <div slot="content">
                  页面案件导入，新案件导入流程不变，老案件更新案件
                </div>
                <i class="el-icon-question"></i>
              </el-tooltip>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24" v-if="this.$partB()">
        <el-col :span="8">
          <el-form-item label="文件保留天数:">
            <el-input v-model="fileSaveDay" type="number" :min="-1" :max="1000" placeholder="天数值为-1~1000"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24" v-if="this.$partB()">
        <el-col :span="8">
          <el-form-item label="绑定意图:">
            <el-select v-model="intentionConfId" filterable clearable  placeholder="请选择" style="width: 100%;">
              <el-option v-for="item in intentionConfs" :key="item.id" :label="item.confName" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="8">
          <el-form-item label="策略基准点数:">
            <el-input v-model="strategyPointNew" type="number" :min="0" :max="24" placeholder="基准时间值为0~24"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="6">
          <el-form-item label="是否重呼:" v-if="this.$partB()">&nbsp;&nbsp;&nbsp;
            <el-switch
              v-model="isRetry"
              active-color="#f6ac19"
              inactive-color="#282828">
            </el-switch>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24" v-if="this.$partB() && isRetry">
        <el-col :span="8">
          <el-form-item label="重呼次数:">
            <el-input v-model="retryCount" type="number" :min="0" :max="24" placeholder="请输入重呼次数"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24" v-if="this.$partB() && isRetry">
        <el-col :span="12">
          <el-form-item label="重呼条件:">
            <el-input v-model="retryCondition" type="textarea" :rows="2"  placeholder="请输入重呼条件，多个条件分号隔开"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="8">
          <h2 style="center:true;">定时策略发送时间</h2>&nbsp;&nbsp;&nbsp;
        </el-col>
      </el-row>
      <br/>
      <el-row :gutter="24">
        <el-col :span="16">
          <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
            <div style="margin: 15px 0;"></div>
            <el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange">
              <el-checkbox v-for="city in cities" :label="city" :key="city">{{city}}</el-checkbox>
            </el-checkbox-group>
        </el-col>
      </el-row>
      <br/>
      <el-row :gutter="24">
        <el-col :span="6">
          <el-time-picker
            v-model="startTime"
            format="HH:mm:ss"
            value-format="HH:mm:ss">
          </el-time-picker>
        </el-col>
        <el-col :span="6">
          <el-time-picker
            v-model="endTime"
            format="HH:mm:ss"
            value-format="HH:mm:ss">
          </el-time-picker>
        </el-col>
      </el-row>
      <br/>
      <el-col :span="1" :offset="4">
          <div class="text right">
            <el-button type="primary" @click="submitCompanyForm" size="small">保存</el-button>
          </div>
        </el-col>
    </el-form>
  </div>
  <div class="dialog">
      <!-- 绑定合同 -->
      <el-dialog
        title="绑定合同"
        :visible.sync="agreementDivConfigVisible"
        width="40%"
        center>
        <div>
          <el-form size="small" label-width="140px">
            <el-form-item label="合同编号:">
              <el-select v-model="agreements" placeholder="请选择公司合同" style="width: 80%;">
                <el-option v-for="item in agreementList" :key="item" :label="item" :value="item"/>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="agreementDivConfigVisible = false" size="small">取 消</el-button>
          <el-button type="primary" @click="bindAgreement" size="small">绑定合同</el-button>
        </div>
      </el-dialog>
      <!-- 绑定日蚀账号 -->
      <el-dialog
        title="绑定日蚀账号"
        :visible.sync="registerDivConfigVisible"
        width="30%"
        center>
        <div>
          <el-form size="small" label-width="140px">
            <el-form-item label="资易通账号:">
            <el-input v-model="zytUser" style="width: 80%;"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div>
          <el-form size="small" label-width="140px">
            <el-form-item label="资易通密码:">
            <el-input v-model="zytPassword" style="width: 80%;"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="registerDivConfigVisible = false" size="small">取 消</el-button>
          <el-button type="primary" @click="registerZYTFromSubmit" size="small">保存</el-button>
        </div>
      </el-dialog>
  </div>
</div>
</template>
<script>
import { Base64 } from 'js-base64';

const cityOptions = ['周一', '周二', '周三', '周四', '周五', '周六', '周日'];
export default {
  props: [
    'companyIdTemp'
  ],
  data() {
    return {
      currentCompanyId: null,
      onoffswitchPush: true,
      onoffTesting: true,
      onoffTitle: true,
      onoffCaseTitle: false,
      comboxCase: null,
      startTime: '',
      endTime: '',
      checkAll: false,
      checkedCities: ['周一', '周二', '周三', '周四', '周五', '周六', '周日'],
      cities: cityOptions,
      isIndeterminate: true,
      agreementDivConfigVisible: false,
      registerDivConfigVisible: false,
      agreements: null,
      options: [],
      agreement: null,
      zytUsers: null,
      strategyPointNew: null,
      message: '',
      authInfoId: null,
      bankInfoId: null,
      zytPassword: null,
      zytUser: null,
      agreementList: [],
      intentionConfs: [],
      importUpdate: null,
      isRetry: true,
      retryCount: null,
      retryCondition: null,
      mergeGroup: null,
      fileSaveDay: 90,
      intentionConfId: null
    };
  },
  watch: {
    companyIdTemp(companyId) {
      this.currentCompanyId = companyId;
      this.$ajax({
        url: '/company/getCompanyList',
        params: { company: companyId }
      }).then((res) => {
        console.warn('公司设置');
        console.warn(res);
        this.agreement = res.data.authInfo.agreement;
        this.zytUsers = res.data.authInfo.zytUser;
        this.onoffswitchPush = res.data.authInfo.isPush;
        if (res.data.authInfo.isTesting === '1') {
          this.onoffTesting = true;
        } else {
          this.onoffTesting = false;
        }
        this.onoffTitle = res.data.authInfo.isUserTitle;
        this.onoffCaseTitle = res.data.authInfo.isUserCustomTitle;
        this.strategyPointNew = res.data.authInfo.strategyPoint;
        const workDay = res.data.authInfo.workDay;
        if (workDay !== null && workDay !== '') {
          const strs = workDay.split('&');
          this.checkedCities = ['周一', '周二', '周三', '周四', '周五', '周六', '周日'];
          let tt = '';
          strs.forEach((element, index) => {
            if (element === '0') {
              if (tt !== '') {
                this.checkedCities.splice(index - 1, 1);
              } else {
                this.checkedCities.splice(index, 1);
              }
              tt = 1;
            }
          });
        }
        const workTime = res.data.authInfo.workTime;
        if (workTime !== null && workTime !== '') {
          const timeStrs = workTime.split('-');
          this.startTime = timeStrs[0];
          this.endTime = timeStrs[1];
        }
        this.message = res.data.authInfo.messageHead;// 短信抬头
        this.comboxCase = res.data.authInfo.comboxCase;
        this.mergeGroup = res.data.authInfo.mergeGroup;
        this.fileSaveDay = res.data.authInfo.fileSaveDay;
        this.intentionConfId = res.data.authInfo.intentionConfId;
        // 案件导入是否更新
        if (res.data.authInfo.importUpdate) {
          this.importUpdate = res.data.authInfo.importUpdate;
        } else {
          this.importUpdate = 0;
        }
        this.authInfoId = res.data.authInfo.id;
        this.bankInfoId = res.data.bankInfo.id;
        this.isRetry = res.data.authInfo.isRetry;
        this.retryCount = res.data.authInfo.retryCount;
        this.retryCondition = res.data.authInfo.retryCondition;
      }).catch((error) => {
        this.$message({
          type: 'error',
          message: error.message
        });
      });
    }
  },
  mounted() {
    this.getIntentionConfs();
  },
  methods: {
    handleCheckAllChange(val) {
      this.checkedCities = val ? cityOptions : [];
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange(value) {
      const checkedCount = value.length;
      this.checkAll = checkedCount === this.cities.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.cities.length;
    },
    // 保存公司设置
    submitCompanyForm() {
      const req = {};
      req.authInfoId = this.authInfoId;
      req.bankInfoId = this.bankInfoId;
      req.isPush = this.onoffswitchPush;
      req.isTesting = this.onoffTesting;
      req.isUserTitle = this.onoffTitle;
      req.isUserCustomTitle = this.onoffCaseTitle;
      req.strategyPoint = this.strategyPointNew;
      req.isRetry = this.isRetry;
      req.retryCount = this.retryCount;
      req.retryCondition = this.retryCondition;
      if (req.isUserTitle && this.message === '') {
        this.$message({
          type: 'error',
          message: '如选择使用抬头，请保证抬头不为空！'
        });
        return;
      }
      req.comboxCase = this.comboxCase;
      req.mergeGroup = this.mergeGroup;
      req.fileSaveDay = this.fileSaveDay;
      req.intentionConfId = this.intentionConfId;
      req.importUpdate = this.importUpdate;
      const checkedCities = this.checkedCities.toString().replace('周一', '1').replace('周二', '2')
        .replace('周三', '3')
        .replace('周四', '4')
        .replace('周五', '5')
        .replace('周六', '6')
        .replace('周日', '7');
      req.workDay = checkedCities;
      req.startTime = this.startTime;
      req.endTime = this.endTime;
      if (this.startTime !== null && this.endTime !== null) {
        const d = new Date();
        const ft1 = d.setHours(this.startTime.split(':')[0], this.startTime.split(':')[1]);
        const ft2 = d.setHours(this.endTime.split(':')[0], this.endTime.split(':')[1]);
        if (ft1 > ft2) {
          this.$message({
            type: 'error',
            message: '开始时间不能大于结束时间'
          });
          return;
        }
      }
      console.warn(req);
      this.$ajax({
        prompt: true,
        url: '/company/updateCompanySet',
        data: req
      }).then((res) => {
        console.warn(res);
      }).catch((error) => {
        this.$message({
          type: 'error',
          message: error.message
        });
      });
    },
    registerZYTShow() {
      this.zytUser = null;
      this.zytPassword = null;
      this.registerDivConfigVisible = true;
    },
    // 绑定资易通账号
    registerZYTFromSubmit() {
      const req = {};
      req.id = this.authInfoId;
      req.zytUser = this.zytUser;
      req.zytPassword = Base64.encode(this.zytPassword);
      this.$ajax({
        prompt: true,
        url: '/company/registerZYT',
        data: req
      }).then((res) => {
        console.warn(res);
        this.registerDivConfigVisible = false;
        this.zytUsers = req.zytUser;
      }).catch((error) => {
        this.$message({
          type: 'error',
          message: error.message
        });
      });
    },
    getAgreement() {
      this.$ajax({
        url: `/company/agreementList/${this.currentCompanyId}`,
        method: 'GET'
      }).then((res) => {
        this.agreementList = res.data;
      });
    },
    // 绑定合同
    bindAgreement() {
      const req = {
        companyId: this.currentCompanyId,
        agreement: this.agreements
      };
      this.$ajax({
        url: '/company/bindAgreement',
        method: 'POST',
        data: req
      }).then(() => {
        this.agreementDivConfigVisible = false;
        this.agreement = this.agreements;
      });
    },
    // 获取意图配置列表
    getIntentionConfs() {
      this.$ajax({
        url: '/intentionConf/listBySelect',
        method: 'GET'
      }).then((res) => {
        this.intentionConfs = res.data;
      });
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/page/main/company/company_set.vue